import { User, IdTokenClaims } from "oidc-client-ts";
import { jwtDecode } from "jwt-decode";
import {
  AddOnEntitlements,
  MemberGroups,
  PremiumEntitlements,
} from "shared-types";
import { checkIsAgent } from "../../utils/checkIsAgent";
import { SL_MEMBER_GROUP, UserAttributes } from "./constants";
import config from "../../config";

const oidcStorageKey = `oidc.user:${config.oidc?.authority}:${config.oidc?.clientId}`;

export function getUser() {
  const oidcStorage = localStorage.getItem(oidcStorageKey);

  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

export function setUerToStorage(user: User) {
  localStorage.setItem(oidcStorageKey, user.toStorageString());
}

export function getJwtClaims(): IdTokenClaims | null {
  const user = getUser();

  if (!user) {
    return null;
  }

  return jwtDecode(user.access_token);
}

export function getUserGroup(): MemberGroups {
  const user = getUser();

  return (
    (user?.profile?.[SL_MEMBER_GROUP] as MemberGroups) ||
    MemberGroups.defaultUser
  );
}

export function doesUserHaveEntitlements(
  feature: PremiumEntitlements | AddOnEntitlements
): boolean {
  const jwtClaims = getJwtClaims();
  const isAgent = checkIsAgent();

  if (!jwtClaims) return false;

  if (isAgent) return true;

  const userEntitlements = jwtClaims["entitlements"] || "[]";
  const parsedEntitlements = JSON.parse(userEntitlements as string);

  if (parsedEntitlements.length === 0) {
    return false;
  }

  return parsedEntitlements.some(
    (entitlement: string) => entitlement === feature
  );
}

export function getUserAttribute<T extends string>(
  attr: UserAttributes,
  defaultValue?: T
): T {
  const user = getUser();
  const jwtClaims = getJwtClaims();

  if (!user || !jwtClaims) {
    return defaultValue as T;
  }

  return (user.profile[attr] || jwtClaims[attr]) as T;
}

export function getProfileCheckerAuthQueryParams():
  | Record<string, string>
  | undefined {
  const params = new URLSearchParams(window.location.search);

  const provider = params.get("provider");

  if (provider) return { acr_values: `idp:${provider}` };
}

// temporary solution until will be done SL-7896
export function oidcLogout() {
  localStorage.removeItem(oidcStorageKey);
  window.location.replace(config.portalApiLogoutUrl);
}
